import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getRole } from '../../../../../../../reducers';
import phaseLineItemShape from 'types/lineItemPropType';
import WarehouseMerchandiseItemTable from 'warehouseMerchandiseItemTable';
import WarehousePadTable from 'warehousePadTable';
import LevelerTable from 'levelerTable';
import warehouseMerchandiseItem from 'types/warehouseMerchandiseItem';
import { isEqual } from 'lodash';
import { can } from '../../../../../../../services';
import ReceiveReleaseAll from 'components/LineItemTable/components/receiveReleaseAll';
import { cutQuantityString } from '../../../../../../../utils/lineItemUtils';
import {
  requestPhaseItems,
  savePhaseItem,
  requestPhaseLevelerItems,
} from 'actionCreators/phase_items';

class WarehouseMaterials extends Component {
  state = {
    pads: [],
  }
  componentWillMount = () => {
    this.props.requestPhaseItems(this.props.params.id, 'phaseLineItems');
    this.props.requestPhaseItems(this.props.params.id, 'warehouseMerchandiseItems');
    this.props.requestPhaseLevelerItems(this.props.params.id, 'levelers');
    this.setState({ pads: this.parsePads(this.props.lineItemsWarehousePads) });
  }
  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps.lineItemsWarehousePads, this.props.lineItemsWarehousePads)) {
      // shutup eslint. I know what I'm doing, I think...
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ pads: this.parsePads(this.props.lineItemsWarehousePads) });
    }
  }

  parsePads = lineItemsPad => lineItemsPad.map(lineItem => ({
    cut_quantity: cutQuantityString(lineItem.warehouse_quantity),
    description: lineItem.description,
  }))

  handleSavePads = (lineItem) => {
    this.props.savePhaseItem(this.props.params.id, lineItem, 'phaseLineItems');
  }

  render = () => {
    const { params, lineItemsWarehousePads, role, lineItemsWarehouseMerchandise } = this.props;
    const editable = can(role, 'update', 'warehouse');
    return (<div>
      <ReceiveReleaseAll
        warehouseMerch={lineItemsWarehouseMerchandise}
        warehousePads={lineItemsWarehousePads}
        phaseId={params.id}
      />
      <WarehouseMerchandiseItemTable
        padInfo={this.state.pads}
        lineItems={lineItemsWarehouseMerchandise}
        editable={editable}
        phaseId={params.id}
      />
      <WarehousePadTable
        handleSave={this.handleSavePads}
        editable={editable}
        lineItems={lineItemsWarehousePads}
        phaseId={params.id}
      />
      <LevelerTable
        lineItems={lineItemsWarehouseMerchandise}
        editable={editable}
        phaseId={params.id}
      />
    </div>
    );
  }
}
WarehouseMaterials.propTypes = {
  lineItemsWarehousePads: PropTypes.arrayOf(
    PropTypes.shape(phaseLineItemShape),
  ),
  lineItemsWarehouseMerchandise: PropTypes.arrayOf(
    PropTypes.shape(warehouseMerchandiseItem),
  ),
  requestPhaseItems: PropTypes.func,
  savePhaseItem: PropTypes.func,
  requestPhaseLevelerItems: PropTypes.func,
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
  role: PropTypes.string.isRequired,
};

export default connect(state => ({
  lineItemsWarehousePads: state.phase.phaseLineItems.items.filter((lineItem) => {
    if (state.phase.source === 'IME') {
      return lineItem.kind === 'Pad';
    }
    return lineItem.kind === 'Product';
  }),
  lineItemsWarehouseMerchandise: state.phase.warehouseMerchandiseItems.items,
  role: getRole(state),
}),
  {
    requestPhaseItems,
    savePhaseItem,
    requestPhaseLevelerItems,
  })(WarehouseMaterials);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/index.jsx